import { APIConfiguration } from '@savgroup-front-common/configuration';
import { isFileType } from '@savgroup-front-common/core/helpers/AdditionalInformations/isFileType';
import { AdditionalInformationExtended, Reason } from '@/types';

interface ReasonAdapterArgs {
  reasonSelected?: Reason;
  currentClaimId: string;
}

export const buildFileUploadEndpoints = ({
  claimId,
  id,
}: {
  claimId: string;
  id: string;
}) => {
  return {
    [claimId]: {
      uploadEndpoint: `${APIConfiguration.claim}claims/${claimId}/additionalInformation/${id}/file`,
      deleteEndpoint: `${APIConfiguration.claim}claims/${claimId}/additionalInformation/${id}/file`,
    },
  };
};

export const reasonAdapter = ({
  reasonSelected,
  currentClaimId,
}: ReasonAdapterArgs) => {
  const newNeededInformation = reasonSelected?.neededInformation.reduce<
    AdditionalInformationExtended[]
  >((acc, curr) => {
    const { id } = curr;

    return [
      ...acc,
      {
        ...curr,
        internalId: `${id}_${currentClaimId}`,
        currentClaimId,
        fileUploadEndpoints: isFileType(curr)
          ? buildFileUploadEndpoints({
              claimId: currentClaimId,
              id,
            })
          : undefined,
      },
    ];
  }, []);

  return {
    ...reasonSelected,
    neededInformation: newNeededInformation,
  };
};
